module.exports = __webpack_public_path__ + "img/np.df5ae1a1.svg";